const OCCUPIED_SLOT_EN = /^Cannot remove occupied certification slots; fewer slots at (.+) requested than enrolments require\.$/
const EMPTY_SLOT_TIMES_EN = /^slotTimes: This collection should contain \d+ element or more\.$/

const KNOWN_MESSAGES = {
  'Cannot change certification kind when there are enrolments.':
    'Nie można zmienić rodzaju certyfikacji, gdy są zapisani uczestnicy.',
  "Can't switch certification to free.":
    'Nie można zmienić certyfikacji na bezpłatną.',
  'slotTimes: This collection should contain 1 element or more.':
    'Dodaj co najmniej jedną godzinę certyfikacji.',
}

/**
 * Zwraca polski komunikat błędu API dla formularza terminów certyfikacji.
 */
export default function resolveCertificationTermsApiError(description) {
  if (!description) {
    return null
  }

  if (KNOWN_MESSAGES[description]) {
    return KNOWN_MESSAGES[description]
  }

  const occupiedSlotMatch = description.match(OCCUPIED_SLOT_EN)
  if (occupiedSlotMatch) {
    return `Nie można usunąć zajętego slotu o godzinie ${occupiedSlotMatch[1]}.`
  }

  if (EMPTY_SLOT_TIMES_EN.test(description)) {
    return 'Dodaj co najmniej jedną godzinę certyfikacji.'
  }

  return description
}
